<template>  
    <div>
        <div  v-if="tradingAccountList.totalLiveAccounts > 0">
        	<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleWithdrawal)">
	            <app-twofa  :call_from="request_page"></app-twofa>
	        </div>
			<div v-else>
				<div class="mainTitle text-center my-3"> 
	                <h3 class="mb-4"> {{$t('withdrawal')}}</h3>
	                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
	            </div>
	            <!--loader - message--->
	            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
				<div class="CustomBlockWidth inMiddle-area whitebox p-4 mb-3" > 
					<div class="justify-content-center">
						<!--------------request page---------------------------------->
						<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleWithdrawal">
							<div class="form-group field-wrapper">
								<account-id></account-id>
							</div>
							<div class="form-group field-wrapper " v-if="account_id != ''">
								<input placeholder=" " type="text" v-model="free_margin_currency"  name="free_margin" class="float-field form-control"   readonly />
								<label for="password" class="float-label">{{$t('freeMargin')}}</label>
							</div> 
							<div class="form-group field-wrapper dob" v-if="free_margin !== '' && parseInt(free_margin) == 0">
                                <ul><li class="alert alert-warning"> {{$t('withdrawalMsz1')}}</li></ul>
                            </div>
							<div v-if="free_margin !== '' && parseInt(free_margin) !== 0">
								<div class="form-group flex-wrap d-flex  justify-content-start align-items-center field-wrapper mb-1"> 
									<div class="withdrwal_cardList d-flex w-100 justify-content-center" v-for="(list,key) in allowedWithdrawal"  v-if="parseInt(key) != 4" >
										<ul class="twoColumn flex-wrap depositpaymentMethod w-100">
											<li class="mb-2 mr-2" v-for="(inlist,inkey) in allowedWithdrawal[key]" 
											:class="(parseInt(account_number) == parseInt(inkey))?'selected':''" v-if="inlist.allowed && parseInt(inlist.allowed) == 1">  
												<label class="customRadio-button d-flex justify-content-start align-items-center"  > 
													<div class="lft d-flex align-items-center mr-3">
														<img :src="'../../../../static/fxView/images/'+withdrawalMethod[key]" alt="Bank Account" class="mr-2">
													</div>
													<div class="rft">
														<input type="radio" name="radio" :value="key" v-model="pay_option" v-validate="{ required: true }"  class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('radio') }" ref="radioInput" @click="selectpaymentFunc(key,inkey,inlist[currencyData])">
														<span class="checkmark"></span>
													</div>
													<div class="d-flex flex-wrap">
														<p v-if="showBalPanel">  {{$t('PrincipalWithAmount')}} <strong>{{currencyIcon[currencyData]}} 
														{{parseFloat(inlist[currencyData]).toFixed(2)}}</strong> </p>
														<p v-if="key == 1">{{$t('AccNumber')}} : {{withdrawalMethodResponseDep[key][inkey].account_no}}</p>
														<p v-if="key == 2">{{$t('skrillId')}} : {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}</p>
														<p v-if="key == 3">{{$t('netId')}} : {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}</p>
														<p v-if="key == 5">
															{{$t('creditCardNumber')}} : **** **** **** {{withdrawalMethodResponseDep[key][inkey].last_digit_card}} 
															<br>
															{{$t('expiryDate')}} : {{withdrawalMethodResponseDep[key][inkey].card_month}}/{{withdrawalMethodResponseDep[key][inkey].card_year}}
														</p>
													</div>
												</label>
											</li>
										</ul> 
									</div> 
								</div>
								<div class="form-group flex-wrap d-flex  justify-content-start align-items-center field-wrapper mb-3"> 
									<div class="withdrwal_cardList d-flex w-100 justify-content-center" v-for="(list,key) in allowedWithdrawal"  v-if="parseInt(key) != 4" >
										<ul class="twoColumn flex-wrap depositpaymentMethod w-100">
											<li class="mb-2 mr-2" v-for="(inlist,inkey) in allowedWithdrawal[key]" v-if="!inlist.allowed">  
												<label class="customRadio-button d-flex justify-content-start align-items-center customdisabled" > 
													<div class="lft d-flex align-items-center mr-3">
														<img :src="'../../../../static/fxView/images/'+withdrawalMethod[key]" alt="Bank Account" class="mr-2">
													</div>
													<div class="rft">
														<input type="radio" name="pay_option_disable" :value="key" v-model="pay_option_disable"  @click="disableOption()">
														<span class="checkmark"></span>
													</div>
													<div class="d-flex flex-wrap">
														<p v-if="showBalPanel">  {{$t('PrincipalWithAmount')}} <strong>{{currencyIcon[currencyData]}} {{inlist[currencyData]}} </strong> </p>
														<p v-if="key == 1">{{$t('AccNumber')}} : {{withdrawalMethodResponseDep[key][inkey].account_no}}</p>
														<p v-if="key == 2">{{$t('skrillId')}} : {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}</p>
														<p v-if="key == 3">{{$t('netId')}}: {{withdrawalMethodResponseDep[key][inkey].online_payment_id}}</p>
														<p v-if="key == 5">
															{{$t('creditCardNumber')}} : **** **** **** {{withdrawalMethodResponseDep[key][inkey].last_digit_card}} 
															<br>
															{{$t('expiryDate')}} : {{withdrawalMethodResponseDep[key][inkey].card_month}}/{{withdrawalMethodResponseDep[key][inkey].card_year}}
														</p>
													</div>
												</label>
											</li>
										</ul> 
									</div>
									<p class="error mb-3" v-if="pay_option == '' && getMsz">{{$t('allowOption')}}</p>
									<p class="error mb-3" v-if="!getMsz && errors.first('radio')">{{$t('WithdrawalMethodReq')}}</p>
								</div>
								<div class="clearfix"></div>
								<!---->
								<!-- <div v-if="Object.keys(allowedWithdrawal).length > 0"> -->
								<div class="mb-3" :class="(Object.keys(allowedWithdrawal).length > 0) ? '' : 'disabled p-3'" >
									<div class="form-group field-wrapper " >
										<input placeholder=" " type="text" v-model="amount"  v-validate="{ required: true }" name="amount" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('amount') }" ref="amountInput" />
										<label for="password" class="float-label">{{$t('EnterWithdrawal')}} {{$t('amount')}}</label>
										<ul><li v-for="error in errors.collect('amount')">{{ error }}</li></ul>
										<p class="error" v-if="amount_msg != ''">{{amount_msg}}</p>
									</div>
									<div class="clearfix"></div>
									<div v-if="countDownTab" class="withdrawalflipCountDown text-center pt-3 mb-3 alert alert-warning">
										<span class="pt-3">{{$t('requestWithdrawal')}}</span>
									</div>
									<div class="submitButton w-100 mt-2 text-center" >
										<button class="prism_btn btn_sm" v-on:click="submitRequestOtp()" :class="(countDownTab)?'disabled':''"> {{$t('withdrawal')}} </button>
									</div>
								</div>
								<div v-if="Object.keys(allowedWithdrawal).length == 0" class="alert alert-warning">
									<span>Please contact our support team <router-link :to="'/support/requestServiceElement'">click here</router-link> to withdraw the amount.</span>
								</div>
							</div>
						</div>

						<!------------------------------------------------------------->
						<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleWithdrawal">
							<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
								<p class="mb-3 text-center">{{$t('googleAuth1')}} <strong>{{$t('googleAuth2')}}</strong> {{$t('googleAuth3')}}. </p>
								<div class="form-group field-wrapper">
									<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedCheckOtp && errors.has('otp') }" ref="otpInput">
									<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
								</div> 
								<div class="form-group text-center field-wrapper">
									<button class="prism_btn btn_sm " v-on:click="submitCheckOtp()">{{$t('validate')}} </button>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
									<div class="desc text-center">
										<p>{{$t('googleAuth4')}} <a v-on:click="resendLink()" href="#"><strong>{{$t('googleAuth5')}}</strong></a></p>
									</div>
								</div>
								<div class="clearfix"></div>
							</div>

							<div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
								<div class="congratulations">
									<div class="logo_congrats">
										<img src="../../../../static/fxView/images/withdraw.svg" alt="Icon">
									</div>
									<div class="subtitle">
										<p class="mb-3">{{$t('dear')}} <strong class="green">{{get_user.username}} !</strong>
											{{$t('withdrawalAuthMessage')}} <strong>{{get_user.email}} . </strong> 
										</p>
										<a v-on:click="resendLink()" href="#" class="mb-3"><strong>{{$t('googleAuth7')}}</strong></a>
									</div>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
									<div class="ico mr-3">
										<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
									</div>
									<div class="desc w-75">
										<h5 class="mb-2"><strong>{{$t('googleAuth8')}}</strong></h5>
											<p>{{$t('googleAuth9')}} <a v-on:click="authComponent = true" href="#"><strong>{{$t('googleAuth10')}}</strong></a></p>
									</div>
								</div>
							</div>
						</div>
						<!------------congo msz final for withdrawal page------------------------->
						<div class="stepForm" v-if="congModuleWithdrawal">
							<div class="congratulations">
								<div class="logo_congrats">
									<img src="../../../../static/fxView/images/check.svg" alt="Icon">
								</div>
								<div class="subtitle">
									<h3>{{$t('congo')}} <span class="green">{{get_user.username}}</span></h3>
									<p>{{$t('withdrawalMsz2')}}</p>
									
								</div>
								<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
									<router-link :to="'/account-list'" class="prism_btn btn_sm">{{$t('goBackMangeAcc')}}</router-link>
								</div>
							</div> 
						</div> 
					</div> 
				</div> 
				<div class="CustomBlockWidth inMiddle-area whitebox p-4" v-if="transaction_id == '' && !congModuleWithdrawal">
					<div class="note-list" >
						<ul class="dotIco">
							<li>{{$t('withCont1')}}</li>
							<li>{{$t('withCont2')}}</li>
							<li>{{$t('withCont3')}}</li>
						</ul>
				   </div>
				</div>
			</div>
        </div>
		<div v-else-if="tradingAccountList.totalLiveAccounts == 0">
			<div class="mainTitle  text-center my-3">
				<h3>{{$t('noTradingAccFound')}}</h3>
			</div>
			<no-trading-account></no-trading-account>
		</div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('plzWaitWhileProc')}}</h4>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
	import FlipCountdown from 'vue2-flip-countdown'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import twoFa from '../users/2FA' 
	import moment from 'moment'
    export default {
        name: 'Withdrawal',
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
            	//============message and loader ===========
                response_msg : '',
                msg_type : '',
				showBalPanel : true,
				amount_msg : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                balance : '',
				free_margin : '',
				allowedWithdrawal : {},
                amount : '',
                pay_option : '',
                account_number : '',

                submitted : false,
                authComponent : false,
                //-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				currencyData : '',
				free_margin_currency : '',
				//=====================

                otp : '',
                transaction_id : '',
                submittedCheckOtp : false,
                congModuleWithdrawal : false,
				pay_option_disable : '',

                request_page : 'withdrawal' ,
				avalBalance : '',
				currencyIcon :{'EUR' : '€','USD' : '$','GBP' : '£','CHF' : 'CHF','JPY' : '¥','AUD': '$'},
				finish_date : '',
				countDownTab : false,
				getMsz : false
            }
        },
        components: {
            appTwofa: twoFa , FlipCountdown
        },
        methods:{ 
			selectpaymentFunc(getMethodId, getPaymentId , amount){
				this.getMsz = false
				let payment_method_date = moment(this.withdrawalMethodResponseDep[getMethodId][getPaymentId].created).format('YYYY-MM-DD hh:mm:ss');
				this.finish_date = moment(payment_method_date).add(24, 'hours').format('YYYY-MM-DD hh:mm:ss');
				var currentDate = moment().format('YYYY-MM-DD hh:mm:ss');
				if(this.finish_date  <= currentDate){
					this.countDownTab = false
				}else{this.countDownTab = true}
				this.account_number = getPaymentId
				this.avalBalance =  amount
			},
			disableOption(){
				this.getMsz = true
			},
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLink(input_json)
            },
            tradingAcountSelect(){
				let input_json1 = {
                    'globalParams' : {
                        'account_id' : this.account_id,
						'act_account_id' : this.act_account_id	,					
                        'demo_live' : this.demo_live ,
						'currency' : this.currencyData ,						
                        'platform' : this.platform
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetWithdrawalDesc(input_json1)
            },
            submitRequestOtp(){
				this.$trackEvent('CP+Account+Funding+Withdrawals');
				this.$trac
				this.amount_msg = ''
                const _that = this
                _that.submitted = true; 
                _that.$validator.validate().then(valid => {
                    if (valid){
						if(parseFloat(_that.amount) <= parseFloat(_that.free_margin)  &&  parseFloat(_that.amount) <= parseFloat(_that.avalBalance) &&  parseInt(_that.amount) > 0){
							_that.amount_msg = ''
							let input_json={
								'globalParams' :{
									'account_id' : _that.account_id ,
									'act_account_id' : _that.act_account_id,
									'withdrawal_method' : _that.pay_option,
									'method_id' : _that.account_number.toString() ,
									'amount' : _that.amount, 
									"operation" : "WITHDRAWAL"
								},
								'localParams' :{ "parameter" : _that }
							}
							_that._runWithdrawalRequestOtp(input_json)
						}else{
							if(parseFloat(_that.free_margin)  <=  parseFloat(_that.avalBalance)){
								_that.amount_msg = 'Max Amount you can withdraw is '+ _that.free_margin
							}else{
								_that.amount_msg = 'Max Amount you can withdraw is '+ _that.avalBalance
							}
						}
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submitCheckOtp(){
                const _that = this
                _that.submittedCheckOtp = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runWithdrawalCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
            if(this.$store.getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE] != ''){
                this.loaderFuncRun = '0'
            }
            this._runGetWithdrawalMethods({'globalParams' :{},'localParams' :{"parameter" : this , 'loaderFuncRun' : this.loaderFuncRun} })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/withdrawal/withdrawal.vue